let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("a3cvU")).then(() => parcelRequire('8XP6i'));